import React, { createContext, useContext, ReactNode, useMemo } from "react";
import { Issue } from "generated-graphql/graphql";
import { Reviewer } from "components/Submission/ReviewersEditList";

interface SubmissionFormContextType {
  issues: Issue[];
}

const SubmissionFormContext = createContext<
  SubmissionFormContextType | undefined
>(undefined);

interface SubmissionFormProviderProps {
  children: ReactNode;
  issues: Issue[];
}

export function SubmissionFormProvider({
  children,
  issues,
}: SubmissionFormProviderProps) {
  return (
    <SubmissionFormContext.Provider value={{ issues }}>
      {children}
    </SubmissionFormContext.Provider>
  );
}

export function useSubmissionFormContext() {
  const context = useContext(SubmissionFormContext);
  if (context === undefined) {
    throw new Error(
      "useSubmissionFormContext must be used within a SubmissionFormProvider"
    );
  }
  return context;
}

export function useReviewersIssues() {
  const { issues } = useSubmissionFormContext();
  return useMemo(
    () =>
      issues.filter(
        (i) => i.modelName === "Submission" && i.key === "reviewers"
      ),
    [issues]
  );
}

export function useReviewerIssues() {
  const { issues } = useSubmissionFormContext();
  return useMemo(
    () => issues.filter((i) => i.modelName === "SubmissionReviewer"),
    [issues]
  );
}
